import { Paper, styled } from "@mui/material";

export const LeftGrid = styled(Paper)(() => ({
  
}));

export const RightGrid = styled(Paper)(() => ({
  
}));